import React, { useState, useEffect } from 'react';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject} from '../../../utils/helpers';
import {Accordion, DatePickerCustom, FormError, FormLabel, InputLista, Modal} from '../../common';
import {useFormErrors} from '../../hooks/useFormErrors';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import DataTaggerFormRedux from '../DataTaggerFormRedux';

const VerificacionModal = (props) => {

    const entityInit = {
        id: 0,
        idInhumado: 0,
        fecha: null,
        motivoVerificacion: '',
        idTipoDocumentoVerificador: 0,
        numeroDocumentoVerificador: '',
        apellidoVerificador: '',
        nombreVerificador: '',
        idResultadoVerificacion: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            fecha: props.data.entity.fecha,
            motivoVerificacion: props.data.entity.motivoVerificacion,
            idTipoDocumentoVerificador: props.data.entity.idTipoDocumentoVerificador,
            numeroDocumentoVerificador: props.data.entity.numeroDocumentoVerificador,
            apellidoVerificador: props.data.entity.apellidoVerificador,
            nombreVerificador: props.data.entity.nombreVerificador,
            idResultadoVerificacion: props.data.entity.idResultadoVerificacion
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        fecha: null,
        motivoVerificacion: '',
        idTipoDocumentoVerificador: 0,
        numeroDocumentoVerificador: '',
        apellidoVerificador: '',
        nombreVerificador: '',
        idResultadoVerificacion: 0
    });

    const CAMPOS_VERIFICACION = ['fecha', 'idResultadoVerificacion', 'motivoVerificacion'];
    const CAMPOS_VERIFICADOR = ['idTipoDocumentoVerificador', 'numeroDocumentoVerificador', 'apellidoVerificador', 'nombreVerificador'];
    const [verificacionOpen, setVerificacionOpen] = useState(true);
    const [verificadorOpen, setVerificadorOpen] = useState(false);
    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        const errors = getErrors();
        if (CAMPOS_VERIFICACION.some(campo => errors[campo])) setVerificacionOpen(true);
        if (CAMPOS_VERIFICADOR.some(campo => errors[campo])) setVerificadorOpen(true);
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.fecha = formValues.fecha;
        row.motivoVerificacion = formValues.motivoVerificacion;
        row.idTipoDocumentoVerificador = parseInt(formValues.idTipoDocumentoVerificador);
        row.numeroDocumentoVerificador = formValues.numeroDocumentoVerificador;
        row.apellidoVerificador = formValues.apellidoVerificador;
        row.nombreVerificador = formValues.nombreVerificador;
        row.idResultadoVerificacion = parseInt(formValues.idResultadoVerificacion);

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.fecha == null) errors.fecha = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (formValues.idResultadoVerificacion <= 0) errors.idResultadoVerificacion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.motivoVerificacion.length === 0) errors.motivoVerificacion = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.idTipoDocumentoVerificador <= 0) errors.idTipoDocumentoVerificador = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.numeroDocumentoVerificador.length === 0) errors.numeroDocumentoVerificador = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.apellidoVerificador.length === 0) errors.apellidoVerificador = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.nombreVerificador.length === 0) errors.nombreVerificador = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Verificación: ${(state.entity.id > 0) ? `N° ${state.entity.id}` : "Nueva"}`}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Verificación" open={verificacionOpen} onToggle={setVerificacionOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-3 col-xl-3">
                                                <FormLabel htmlFor="fecha" required>Fecha</FormLabel>
                                                <DatePickerCustom
                                                    name="fecha"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fecha') ? 'is-invalid' : ''}`}
                                                    value={formValues.fecha}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fecha')} />
                                            </div>

                                            <div className="mb-3 col-12 col-md-9 col-xl-9">
                                                <FormLabel htmlFor="idResultadoVerificacion"
                                                       required>Resultado</FormLabel>
                                                <InputLista
                                                    name="idResultadoVerificacion"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idResultadoVerificacion') ? 'is-invalid' : ''}`}
                                                    value={formValues.idResultadoVerificacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="ResultadoVerificacion"
                                                />
                                                <FormError message={errorOf('idResultadoVerificacion')} />
                                            </div>
                                            <div className="mb-3 col-12">
                                                <FormLabel htmlFor="motivoVerificacion" required>Motivo de
                                                    verificación</FormLabel>
                                                <input
                                                    name="motivoVerificacion"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('motivoVerificacion') ? 'is-invalid' : ''}`}
                                                    value={formValues.motivoVerificacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('motivoVerificacion')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Verificador/a" open={verificadorOpen} onToggle={setVerificadorOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6 col-xl-3">
                                                <FormLabel htmlFor="idTipoDocumentoVerificador" required>Tipo
                                                    de documento</FormLabel>
                                                <InputLista
                                                    name="idTipoDocumentoVerificador"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoDocumentoVerificador') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoDocumentoVerificador}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoDocumento"
                                                />
                                                <FormError message={errorOf('idTipoDocumentoVerificador')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-xl-3">
                                                <FormLabel htmlFor="numeroDocumentoVerificador" required>N°
                                                    de documento</FormLabel>
                                                <input
                                                    name="numeroDocumentoVerificador"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('numeroDocumentoVerificador') ? 'is-invalid' : ''}`}
                                                    value={formValues.numeroDocumentoVerificador}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('numeroDocumentoVerificador')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-xl-3">
                                                <FormLabel htmlFor="apellidoVerificador"
                                                       required>Apellido</FormLabel>
                                                <input
                                                    name="apellidoVerificador"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('apellidoVerificador') ? 'is-invalid' : ''}`}
                                                    value={formValues.apellidoVerificador}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('apellidoVerificador')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6 col-xl-3">
                                                <FormLabel htmlFor="nombreVerificador"
                                                       required>Nombre</FormLabel>
                                                <input
                                                    name="nombreVerificador"
                                                    type="text"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('nombreVerificador') ? 'is-invalid' : ''}`}
                                                    value={formValues.nombreVerificador}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('nombreVerificador')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de verificación"
                                            processKey={props.processKey}
                                            entidad="Verificacion"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>


                            </div>

                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}


VerificacionModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

VerificacionModal.defaultProps = {
    disabled: false
};

export default VerificacionModal;
